module.exports = __webpack_public_path__ + "static/jan_1-6edb1ff77b3dac5657e4036496fe06f0.mp4";